import React from 'react'

export default function AboutMe() {
 
  return (
    <div className="aboutme-container">

      <div className="aboutme-bigger-container">

      <div>
        <h1 data-aos="flip-up" className="aboutme-name">Hello,</h1>
        <div data-aos="flip-up"><span>I'm <span data-aos="flip-up" className="aboutme-jason">Jason Kang,</span></span></div>
        <div data-aos="flip-up" className="aboutme-full-stack">a Software Engineer.</div>
      </div>

      </div>
     
        <div className="aboutme-resume-linkedin-github" data-aos="fade-up">
        
        <div className="aboutme-resume-container">
        <a href="https://drive.google.com/file/d/12zIClmYsOuJgv-hKNzXzYXKbgF2QZ6QN/view?usp=sharing" target="blank">
        <img className="aboutme-resume" alt="resume" src="/images/resume.svg" /> 
        <p>Resume</p>
        </a>
        </div>

        <a href="https://www.linkedin.com/in/jason-hk-kang" target="blank">
          <img className="aboutme-linkedin" alt="linkedin" src="/images/linkedin.svg" /> 
        <p>LinkedIn</p>
        </a>

        <a href="https://github.com/kangja" target="blank">
            <img className="aboutme-github" alt="github" src="/images/github.svg" /> 
            <p>Github</p>
            
        </a>

        </div>
        
      </div>
  )
}
